module.exports = __webpack_public_path__ + "assets/webgl/FloorPattern.jpg.pvr.d4a1b9d7.ktx";